<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.edit', inspection]]" [routerLink]="getEditRoute()">
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.score.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-row" *ngIf="scoreData.Score !== null && scoreData.Score >= 0">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.score.score' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ scoreData.Score }}</span>
        </p>
      </div>
    </div>
    <div class="ir-row" *ngIf="scoreData.Comment">
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span><strong>{{ 'plugins.score.comment' | translate }}</strong></span>
        </p>
      </div>
      <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
        <p>
          <span>{{ scoreData.Comment }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
